import type { Hero } from 'src/types/infra/supabase'
import One55SymbolWhite from 'src/app/assets/icons/ico-155-symbol.svg'
import { LoadingMessages } from './components/LoadingMessages'

type Props = Readonly<{
  hero?: Hero
}>

export function LoadingIndicator({ hero }: Props) {
  return (
    <div className="race-loading-indicator-outer">
      <div className="race-loading-indicator">
        <div className="race-loading-indicator__inner">
          <One55SymbolWhite />
          <div className="text">
            <LoadingMessages />
          </div>
          <div className="progress-bar-outer">
            <span className="progress-bar" />
          </div>
        </div>
      </div>
      {hero ? (
        <div className="loading-indicator__background">
          {hero.image ? (
            <video
              autoPlay
              controlsList="nodownload"
              disablePictureInPicture
              loop
              muted
              playsInline
              poster={`/assets/tracks-backgrounds/${hero.image}.webp`}
              src={`/assets/tracks-backgrounds/${hero.image}-video.mp4`}
            />
          ) : null}
        </div>
      ) : (
        <div className="loading-indicator__background">
          <img alt="" src="/assets/marbles-racetrack-loading-screen.webp" />
        </div>
      )}
    </div>
  )
}
